export { default } from "./Carousel"
